import classNames from "classnames";
import { useState } from "react";
import { CustomProgressBar } from "@design-system/CustomProgressBar/CustomProgressBar";
import {
    ProgressIndicator,
    ProgressRoot,
    ProgressTrack,
    ProgressValue,
} from "@design-system/ProgressBar/ProgressBar";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { RangeControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./FeedbackPlayground.module.scss";

type ProgressBarSize = "lg" | "sm";

export const ProgressBarsPlayground = () => {
    const [value, setValue] = useState(64);
    const [size, setSize] = useState<ProgressBarSize>("lg");

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Value</h2>
                        <RangeControl
                            label={`${value}%`}
                            value={value}
                            onChange={setValue}
                            min={0}
                            max={100}
                        />
                    </section>
                    <section>
                        <h2>Custom bar size</h2>
                        <ToggleGroup.Root
                            value={size}
                            onValueChange={(nextSize) => {
                                if (nextSize === "lg" || nextSize === "sm") {
                                    setSize(nextSize);
                                }
                            }}
                        >
                            <ToggleGroup.Item value="lg">lg</ToggleGroup.Item>
                            <ToggleGroup.Item value="sm">sm</ToggleGroup.Item>
                        </ToggleGroup.Root>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`${value}% complete`}
                output={JSON.stringify(
                    {
                        progressRoot: { value },
                        customProgressBar: {
                            value,
                            max: 100,
                            size,
                        },
                    },
                    null,
                    2,
                )}
            >
                <div className={classNames(styles.surface, styles.stack)}>
                    <section className={styles.stack}>
                        <h2>Progress bar</h2>
                        <ProgressRoot value={value}>
                            <ProgressTrack>
                                <ProgressIndicator />
                            </ProgressTrack>
                            <ProgressValue />
                        </ProgressRoot>
                    </section>
                    <section className={styles.stack}>
                        <h2>Custom progress bar</h2>
                        <CustomProgressBar
                            value={value}
                            max={100}
                            size={size}
                            renderValue={(currentValue) =>
                                `${currentValue}% used`
                            }
                            renderMax={(max) => `${max}% available`}
                        />
                    </section>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
